var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { cachedSet, sortedSet } from '../../../../../utils/mobx/decorators/customComputed';
import { traitRegistry } from '../../../../../registry/Registry';
import { flatten, uniq } from '../../../../../utils/helper/lodash_replacements';
export class AspectActive {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent.aspect;
    }
    get activeTraits() {
        return uniq(flatten(this.aspect.aspectTraits.traitKeysWithDerived.map(traitKey => this.parent.aspectKey(traitKey).keyActive.activeTraits))).sort((at1, at2) => at2.prio - at1.prio);
    }
    get activeTraitKeys() {
        return uniq(this.activeTraits.map(at => at.key));
    }
    get activeObject() {
        const activeObject = this.activeTraitKeys.reduce((returnObj, traitKey) => {
            if (!traitRegistry.registry_object[traitKey]) {
                console.log(`kein trait registry für ${traitKey}`);
            }
            returnObj[traitKey] = this.aspect.activeOf[traitKey];
            return returnObj;
        }, {});
        return activeObject;
    }
    // @computed get traitsObject(){ return this.traitsObj.toJS();}
    get activeValuesObject() {
        return Object.entries(this.activeObject).reduce((a, [key, atOrAtList]) => {
            a[key] = Array.isArray(atOrAtList)
                ? atOrAtList.map((at) => at.attachedValue)
                : atOrAtList.attachedValue;
            return a;
        }, {});
    }
}
__decorate([
    sortedSet
], AspectActive.prototype, "activeTraits", null);
__decorate([
    cachedSet
], AspectActive.prototype, "activeTraitKeys", null);
__decorate([
    computed
], AspectActive.prototype, "activeObject", null);
__decorate([
    computed
], AspectActive.prototype, "activeValuesObject", null);
